function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// +----------------------------------------------------------------------
// | CNXRC [ CNXRC赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.cnxrc.net All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CNXRC并不是自由软件，未经许可不能去掉CNXRC相关版权
// +----------------------------------------------------------------------
// | Author: CNXRC Team <admin@cnxrc.net>
// +----------------------------------------------------------------------

import request from '@/utils/request';
import { getAdminModule } from '@/utils/settingMer';
var adminModuleBase = function adminModuleBase() {
  return "/admin/".concat(getAdminModule());
};

/**
 * 文件上传
 * @param data
 */
export function fileFileApi(data, params) {
  return request({
    url: '/publicly/upload/file',
    method: 'POST',
    params: params,
    data: data
  });
}

/**
 * 图片上传
 * @param data
 */
export function fileImageApi(data, params) {
  return request({
    url: "".concat(adminModuleBase(), "/upload/image"),
    method: 'POST',
    params: params,
    data: data
  });
}

/**
 * 图片列表
 * @param data
 */
export function fileListApi(params) {
  return request({
    url: "".concat(adminModuleBase(), "/attachment/list"),
    method: 'get',
    params: _objectSpread(_objectSpread({}, params), {}, {
      keywords: encodeURI(params.keywords)
    })
  });
}

/**
 * 编辑附件名称
 * @param data
 */
export function attachmentNameUpdateApi(data) {
  return request({
    url: "".concat(adminModuleBase(), "/attachment/name/update"),
    method: 'post',
    data: data
  });
}

/**
 * 图片列表 删除图片
 * @param data
 */
export function fileDeleteApi(id) {
  return request({
    url: "".concat(adminModuleBase(), "/attachment/delete"),
    method: 'post',
    data: {
      ids: id
    }
  });
}

/**
 * 图片列表 移動分類
 * @param data
 */
export function attachmentMoveApi(data) {
  return request({
    url: "".concat(adminModuleBase(), "/attachment/move"),
    method: 'post',
    data: data
  });
}

/**
 * 微信开放平台上传素材
 * @param data
 */
export function wechatUploadApi(data, params) {
  return request({
    url: "/admin/platform/wechat/open/media/upload",
    method: 'post',
    data: data,
    params: params
  });
}

/**
 * 商户主体小票打印配置列表
 */
export function businessPrintListApi(params) {
  return request({
    url: '/admin/business/print/list',
    method: 'get',
    params: params
  });
}

/**
 * 商户主体小票打印配置删除
 */
export function businessPrintDeleteApi(id) {
  return request({
    url: "/admin/business/print/delete/".concat(id),
    method: 'get'
  });
}

/**
 * 商户主体小票打印配置新增
 */
export function businessPrintSaveApi(data) {
  return request({
    url: '/admin/business/print/save',
    method: 'post',
    data: data
  });
}

/**
 * 商户主体小票打印配置状态
 */
export function businessPrintStatusApi(data) {
  return request({
    url: '/admin/business/print/status',
    method: 'post',
    data: data
  });
}

/**
 * 商户主体小票打印配置编辑
 */
export function businessPrintUpdateApi(data) {
  return request({
    url: '/admin/business/print/update',
    method: 'post',
    data: data
  });
}

/**
 * 商户主体电子面单详情
 */
export function businessElectInfoApi() {
  return request({
    url: '/admin/business/elect/info',
    method: 'get'
  });
}

/**
 * 商户主体电子面单编辑
 */
export function businessElectUpdateApi(data) {
  return request({
    url: '/admin/business/elect/update',
    method: 'post',
    data: data
  });
}

/**
 * 商户主体地址列表
 */
export function businessAddressListApi(params) {
  return request({
    url: '/admin/business/address/list',
    method: 'get',
    params: params
  });
}

/**
 * 商户主体地址删除
 */
export function businessAddressDeleteApi(id) {
  return request({
    url: "/admin/business/address/delete/".concat(id),
    method: 'get'
  });
}

/**
 * 商户主体地址新增
 */
export function businessAddressSaveApi(data) {
  return request({
    url: '/admin/business/address/save',
    method: 'post',
    data: data
  });
}

/**
 * 商户主体地址编辑
 */
export function businessAddressUpdateApi(data) {
  return request({
    url: '/admin/business/address/update',
    method: 'post',
    data: data
  });
}

/**
 * 商户主体地址设为默认
 */
export function businessAddressSetDefaultApi(id) {
  return request({
    url: "/admin/business/address/set/default/".concat(id),
    method: 'post'
  });
}

/**
 * 商户主体地址开启状态
 */
export function businessAddressUpdateShowApi(id) {
  return request({
    url: "/admin/business/address/update/show/".concat(id),
    method: 'post'
  });
}

/**
 * 商户主体基础信息
 */
export function businessBaseInfoApi() {
  return request({
    url: '/admin/business/base/info',
    method: 'get'
  });
}

/**
 * 商户主体配置信息
 */
export function businessConfigInfoApi() {
  return request({
    url: '/admin/business/config/info',
    method: 'get'
  });
}

/**
 * 商户主体配置信息编辑
 */
export function businessConfigInfoEditApi(data) {
  return request({
    url: '/admin/business/config/info/edit',
    method: 'post',
    data: data
  });
}

/**
 * 商户主体商品审核开关信息
 */
export function businessProductAuditSwitchInfoApi() {
  return request({
    url: '/admin/business/product/audit/switch/info',
    method: 'get'
  });
}

/**
 * 商户主体开关
 */
export function businessSwitchUpdateApi() {
  return request({
    url: '/admin/business/switch/update',
    method: 'post'
  });
}